import { render } from "./EventCheckin.vue?vue&type=template&id=b2876dfe&scoped=true"
import script from "./EventCheckin.vue?vue&type=script&lang=js"
export * from "./EventCheckin.vue?vue&type=script&lang=js"

import "./EventCheckin.vue?vue&type=style&index=0&id=b2876dfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2876dfe"]])

export default __exports__